import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const BookingsEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		bookingreference: yup.string().required().label("Bookingreference"),
		userid: yup.string().required().label("Userid"),
		serviceid: yup.string().required().label("Serviceid"),
		status: yup.string().required().label("Status"),
		pickupdate: yup.string().required().label("Pickupdate"),
		deliverydate: yup.string().required().label("Deliverydate"),
		pickuptimeslot: yup.string().nullable().label("Pickuptimeslot"),
		deliverytimeslot: yup.string().nullable().label("Deliverytimeslot"),
		pickupaddress: yup.string().required().label("Pickupaddress"),
		deliveryaddress: yup.string().required().label("Deliveryaddress"),
		pickuplatitude: yup.number().nullable().label("Pickuplatitude"),
		pickuplongitude: yup.number().nullable().label("Pickuplongitude"),
		deliverylatitude: yup.number().nullable().label("Deliverylatitude"),
		deliverylongitude: yup.number().nullable().label("Deliverylongitude"),
		totalweight: yup.number().nullable().label("Totalweight"),
		totalitems: yup.number().nullable().label("Totalitems"),
		baseamount: yup.number().required().label("Baseamount"),
		weightcharge: yup.number().nullable().label("Weightcharge"),
		extracharges: yup.number().nullable().label("Extracharges"),
		discountamount: yup.number().nullable().label("Discountamount"),
		taxrate: yup.number().nullable().label("Taxrate"),
		taxamount: yup.number().nullable().label("Taxamount"),
		totalamount: yup.number().required().label("Totalamount"),
		specialinstructions: yup.string().nullable().label("Specialinstructions"),
		preferredcontactmethod: yup.string().nullable().label("Preferredcontactmethod"),
		deliveryinstructions: yup.string().nullable().label("Deliveryinstructions"),
		paymentstatus: yup.string().nullable().label("Paymentstatus"),
		paymentmethod: yup.string().nullable().label("Paymentmethod"),
		transactionid: yup.string().nullable().label("Transactionid"),
		paymentdate: yup.string().nullable().label("Paymentdate"),
		assignedstaffid: yup.string().nullable().label("Assignedstaffid"),
		assigneddriverid: yup.string().nullable().label("Assigneddriverid"),
		createdat: yup.string().required().label("Createdat"),
		updatedat: yup.string().required().label("Updatedat"),
		confirmedat: yup.string().nullable().label("Confirmedat"),
		pickedupat: yup.string().nullable().label("Pickedupat"),
		processingstartedat: yup.string().nullable().label("Processingstartedat"),
		readyfordeliveryat: yup.string().nullable().label("Readyfordeliveryat"),
		outfordeliveryat: yup.string().nullable().label("Outfordeliveryat"),
		deliveredat: yup.string().nullable().label("Deliveredat"),
		completedat: yup.string().nullable().label("Completedat"),
		cancelledat: yup.string().nullable().label("Cancelledat"),
		cancelledreason: yup.string().nullable().label("Cancelledreason"),
		cancelledby: yup.string().nullable().label("Cancelledby"),
		customerrating: yup.number().nullable().label("Customerrating"),
		customerreview: yup.string().nullable().label("Customerreview"),
		reviewdate: yup.string().nullable().label("Reviewdate"),
		isurgent: yup.string().nullable().label("Isurgent"),
		prioritylevel: yup.number().nullable().label("Prioritylevel"),
		isrepeatcustomer: yup.string().nullable().label("Isrepeatcustomer"),
		source: yup.string().nullable().label("Source"),
		createdby: yup.string().nullable().label("Createdby"),
		modifiedby: yup.string().nullable().label("Modifiedby"),
		pickupconfirmedby: yup.number().nullable().label("Pickupconfirmedby"),
		deliveryconfirmedby: yup.number().nullable().label("Deliveryconfirmedby"),
		partnerid: yup.string().nullable().label("Partnerid"),
		paymentid: yup.string().nullable().label("Paymentid"),
		quantity: yup.number().nullable().label("Quantity")
	});
	// form default values
	const formDefaultValues = {
		bookingreference: "((format(getdate(),'yyyyMMdd+'-+right00000'+CONVERT([nvarchar](10),NEXT VALUE FOR [BookingSequence]),(5)))", 
		userid: '', 
		serviceid: '', 
		status: "Pending", 
		pickupdate: new Date(), 
		deliverydate: new Date(), 
		pickuptimeslot: new Date(), 
		deliverytimeslot: new Date(), 
		pickupaddress: '', 
		deliveryaddress: '', 
		pickuplatitude: '', 
		pickuplongitude: '', 
		deliverylatitude: '', 
		deliverylongitude: '', 
		totalweight: "((0))", 
		totalitems: "((0))", 
		baseamount: "((0))", 
		weightcharge: "((0))", 
		extracharges: "((0))", 
		discountamount: "((0))", 
		taxrate: "((0.18))", 
		taxamount: "((0))", 
		totalamount: "((0))", 
		specialinstructions: '', 
		preferredcontactmethod: "Phone", 
		deliveryinstructions: '', 
		paymentstatus: "Pending", 
		paymentmethod: '', 
		transactionid: '', 
		paymentdate: new Date(), 
		assignedstaffid: '', 
		assigneddriverid: '', 
		createdat: "(getdate())", 
		updatedat: "(getdate())", 
		confirmedat: new Date(), 
		pickedupat: new Date(), 
		processingstartedat: new Date(), 
		readyfordeliveryat: new Date(), 
		outfordeliveryat: new Date(), 
		deliveredat: new Date(), 
		completedat: new Date(), 
		cancelledat: new Date(), 
		cancelledreason: '', 
		cancelledby: '', 
		customerrating: '', 
		customerreview: '', 
		reviewdate: new Date(), 
		isurgent: "((0))", 
		prioritylevel: "((1))", 
		isrepeatcustomer: "((0))", 
		source: "Web", 
		createdby: '', 
		modifiedby: '', 
		pickupconfirmedby: '', 
		deliveryconfirmedby: '', 
		partnerid: '', 
		paymentid: '', 
		quantity: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/bookings`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="BookingsEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Booking"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Bookingreference *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bookingreference"  onChange={formik.handleChange}  value={formik.values.bookingreference}   label="Bookingreference" type="text" placeholder="Enter Bookingreference"        className={inputClassName(formik?.errors?.bookingreference)} />
                                                <ErrorMessage name="bookingreference" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Userid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/userid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="userid"     optionLabel="label" optionValue="value" value={formik.values.userid} onChange={formik.handleChange} options={response} label="Userid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.userid)}   />
                                                    <ErrorMessage name="userid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Serviceid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/serviceid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="serviceid"     optionLabel="label" optionValue="value" value={formik.values.serviceid} onChange={formik.handleChange} options={response} label="Serviceid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.serviceid)}   />
                                                    <ErrorMessage name="serviceid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Status *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="status"  onChange={formik.handleChange}  value={formik.values.status}   label="Status" type="text" placeholder="Enter Status"        className={inputClassName(formik?.errors?.status)} />
                                                <ErrorMessage name="status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pickupdate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="pickupdate" value={formik.values.pickupdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.pickupdate)}        />
                                                <ErrorMessage name="pickupdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Deliverydate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="deliverydate" value={formik.values.deliverydate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.deliverydate)}        />
                                                <ErrorMessage name="deliverydate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pickuptimeslot 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="pickuptimeslot" value={formik.values.pickuptimeslot} onChange={formik.handleChange} showButtonBar className={inputClassName(formik?.errors?.pickuptimeslot)}     showTime timeOnly     />
                                                <ErrorMessage name="pickuptimeslot" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Deliverytimeslot 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="deliverytimeslot" value={formik.values.deliverytimeslot} onChange={formik.handleChange} showButtonBar className={inputClassName(formik?.errors?.deliverytimeslot)}     showTime timeOnly     />
                                                <ErrorMessage name="deliverytimeslot" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pickupaddress *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pickupaddress"  onChange={formik.handleChange}  value={formik.values.pickupaddress}   label="Pickupaddress" type="text" placeholder="Enter Pickupaddress"        className={inputClassName(formik?.errors?.pickupaddress)} />
                                                <ErrorMessage name="pickupaddress" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Deliveryaddress *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="deliveryaddress"  onChange={formik.handleChange}  value={formik.values.deliveryaddress}   label="Deliveryaddress" type="text" placeholder="Enter Deliveryaddress"        className={inputClassName(formik?.errors?.deliveryaddress)} />
                                                <ErrorMessage name="deliveryaddress" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pickuplatitude 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pickuplatitude"  onChange={formik.handleChange}  value={formik.values.pickuplatitude}   label="Pickuplatitude" type="number" placeholder="Enter Pickuplatitude"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.pickuplatitude)} />
                                                <ErrorMessage name="pickuplatitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pickuplongitude 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pickuplongitude"  onChange={formik.handleChange}  value={formik.values.pickuplongitude}   label="Pickuplongitude" type="number" placeholder="Enter Pickuplongitude"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.pickuplongitude)} />
                                                <ErrorMessage name="pickuplongitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Deliverylatitude 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="deliverylatitude"  onChange={formik.handleChange}  value={formik.values.deliverylatitude}   label="Deliverylatitude" type="number" placeholder="Enter Deliverylatitude"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.deliverylatitude)} />
                                                <ErrorMessage name="deliverylatitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Deliverylongitude 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="deliverylongitude"  onChange={formik.handleChange}  value={formik.values.deliverylongitude}   label="Deliverylongitude" type="number" placeholder="Enter Deliverylongitude"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.deliverylongitude)} />
                                                <ErrorMessage name="deliverylongitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Totalweight 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalweight"  onChange={formik.handleChange}  value={formik.values.totalweight}   label="Totalweight" type="number" placeholder="Enter Totalweight"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.totalweight)} />
                                                <ErrorMessage name="totalweight" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Totalitems 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalitems"  onChange={formik.handleChange}  value={formik.values.totalitems}   label="Totalitems" type="number" placeholder="Enter Totalitems"  min={0}  step="any"    className={inputClassName(formik?.errors?.totalitems)} />
                                                <ErrorMessage name="totalitems" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Baseamount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="baseamount"  onChange={formik.handleChange}  value={formik.values.baseamount}   label="Baseamount" type="number" placeholder="Enter Baseamount"  min={0}  step={0.01}    className={inputClassName(formik?.errors?.baseamount)} />
                                                <ErrorMessage name="baseamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Weightcharge 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="weightcharge"  onChange={formik.handleChange}  value={formik.values.weightcharge}   label="Weightcharge" type="number" placeholder="Enter Weightcharge"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.weightcharge)} />
                                                <ErrorMessage name="weightcharge" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Extracharges 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="extracharges"  onChange={formik.handleChange}  value={formik.values.extracharges}   label="Extracharges" type="number" placeholder="Enter Extracharges"  min={0}  step={0.01}    className={inputClassName(formik?.errors?.extracharges)} />
                                                <ErrorMessage name="extracharges" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Discountamount 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="discountamount"  onChange={formik.handleChange}  value={formik.values.discountamount}   label="Discountamount" type="number" placeholder="Enter Discountamount"  min={0}  step={0.01}    className={inputClassName(formik?.errors?.discountamount)} />
                                                <ErrorMessage name="discountamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Taxrate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="taxrate"  onChange={formik.handleChange}  value={formik.values.taxrate}   label="Taxrate" type="number" placeholder="Enter Taxrate"  min={0}  step={0.01}    className={inputClassName(formik?.errors?.taxrate)} />
                                                <ErrorMessage name="taxrate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Taxamount 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="taxamount"  onChange={formik.handleChange}  value={formik.values.taxamount}   label="Taxamount" type="number" placeholder="Enter Taxamount"  min={0}  step={0.01}    className={inputClassName(formik?.errors?.taxamount)} />
                                                <ErrorMessage name="taxamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Totalamount *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalamount"  onChange={formik.handleChange}  value={formik.values.totalamount}   label="Totalamount" type="number" placeholder="Enter Totalamount"  min={0}  step={0.01}    className={inputClassName(formik?.errors?.totalamount)} />
                                                <ErrorMessage name="totalamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Specialinstructions 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="specialinstructions"  onChange={formik.handleChange}  value={formik.values.specialinstructions}   label="Specialinstructions" type="text" placeholder="Enter Specialinstructions"        className={inputClassName(formik?.errors?.specialinstructions)} />
                                                <ErrorMessage name="specialinstructions" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Preferredcontactmethod 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="preferredcontactmethod"  onChange={formik.handleChange}  value={formik.values.preferredcontactmethod}   label="Preferredcontactmethod" type="text" placeholder="Enter Preferredcontactmethod"        className={inputClassName(formik?.errors?.preferredcontactmethod)} />
                                                <ErrorMessage name="preferredcontactmethod" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Deliveryinstructions 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="deliveryinstructions"  onChange={formik.handleChange}  value={formik.values.deliveryinstructions}   label="Deliveryinstructions" type="text" placeholder="Enter Deliveryinstructions"        className={inputClassName(formik?.errors?.deliveryinstructions)} />
                                                <ErrorMessage name="deliveryinstructions" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paymentstatus 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentstatus"  onChange={formik.handleChange}  value={formik.values.paymentstatus}   label="Paymentstatus" type="text" placeholder="Enter Paymentstatus"        className={inputClassName(formik?.errors?.paymentstatus)} />
                                                <ErrorMessage name="paymentstatus" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paymentmethod 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentmethod"  onChange={formik.handleChange}  value={formik.values.paymentmethod}   label="Paymentmethod" type="text" placeholder="Enter Paymentmethod"        className={inputClassName(formik?.errors?.paymentmethod)} />
                                                <ErrorMessage name="paymentmethod" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Transactionid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="transactionid"  onChange={formik.handleChange}  value={formik.values.transactionid}   label="Transactionid" type="text" placeholder="Enter Transactionid"        className={inputClassName(formik?.errors?.transactionid)} />
                                                <ErrorMessage name="transactionid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paymentdate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="paymentdate" value={formik.values.paymentdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.paymentdate)}        />
                                                <ErrorMessage name="paymentdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Assignedstaffid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/assignedstaffid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="assignedstaffid"     optionLabel="label" optionValue="value" value={formik.values.assignedstaffid} onChange={formik.handleChange} options={response} label="Assignedstaffid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.assignedstaffid)}   />
                                                    <ErrorMessage name="assignedstaffid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Assigneddriverid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/assignedstaffid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="assigneddriverid"     optionLabel="label" optionValue="value" value={formik.values.assigneddriverid} onChange={formik.handleChange} options={response} label="Assigneddriverid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.assigneddriverid)}   />
                                                    <ErrorMessage name="assigneddriverid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Updatedat *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="updatedat" value={formik.values.updatedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.updatedat)}        />
                                                <ErrorMessage name="updatedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Confirmedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="confirmedat" value={formik.values.confirmedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.confirmedat)}        />
                                                <ErrorMessage name="confirmedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pickedupat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="pickedupat" value={formik.values.pickedupat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.pickedupat)}        />
                                                <ErrorMessage name="pickedupat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Processingstartedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="processingstartedat" value={formik.values.processingstartedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.processingstartedat)}        />
                                                <ErrorMessage name="processingstartedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Readyfordeliveryat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="readyfordeliveryat" value={formik.values.readyfordeliveryat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.readyfordeliveryat)}        />
                                                <ErrorMessage name="readyfordeliveryat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Outfordeliveryat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="outfordeliveryat" value={formik.values.outfordeliveryat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.outfordeliveryat)}        />
                                                <ErrorMessage name="outfordeliveryat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Deliveredat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="deliveredat" value={formik.values.deliveredat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.deliveredat)}        />
                                                <ErrorMessage name="deliveredat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Completedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="completedat" value={formik.values.completedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.completedat)}        />
                                                <ErrorMessage name="completedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Cancelledat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="cancelledat" value={formik.values.cancelledat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.cancelledat)}        />
                                                <ErrorMessage name="cancelledat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Cancelledreason 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="cancelledreason"  onChange={formik.handleChange}  value={formik.values.cancelledreason}   label="Cancelledreason" type="text" placeholder="Enter Cancelledreason"        className={inputClassName(formik?.errors?.cancelledreason)} />
                                                <ErrorMessage name="cancelledreason" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Cancelledby 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/userid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="cancelledby"     optionLabel="label" optionValue="value" value={formik.values.cancelledby} onChange={formik.handleChange} options={response} label="Cancelledby"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.cancelledby)}   />
                                                    <ErrorMessage name="cancelledby" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Customerrating 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customerrating"  onChange={formik.handleChange}  value={formik.values.customerrating}   label="Customerrating" type="number" placeholder="Enter Customerrating"  min={0}  step="any"    className={inputClassName(formik?.errors?.customerrating)} />
                                                <ErrorMessage name="customerrating" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Customerreview 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customerreview"  onChange={formik.handleChange}  value={formik.values.customerreview}   label="Customerreview" type="text" placeholder="Enter Customerreview"        className={inputClassName(formik?.errors?.customerreview)} />
                                                <ErrorMessage name="customerreview" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Reviewdate 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="reviewdate" value={formik.values.reviewdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.reviewdate)}        />
                                                <ErrorMessage name="reviewdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isurgent 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isurgent"  onChange={formik.handleChange}  value={formik.values.isurgent}   label="Isurgent" type="text" placeholder="Enter Isurgent"        className={inputClassName(formik?.errors?.isurgent)} />
                                                <ErrorMessage name="isurgent" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Prioritylevel 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="prioritylevel"  onChange={formik.handleChange}  value={formik.values.prioritylevel}   label="Prioritylevel" type="number" placeholder="Enter Prioritylevel"  min={0}  step="any"    className={inputClassName(formik?.errors?.prioritylevel)} />
                                                <ErrorMessage name="prioritylevel" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isrepeatcustomer 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isrepeatcustomer"  onChange={formik.handleChange}  value={formik.values.isrepeatcustomer}   label="Isrepeatcustomer" type="text" placeholder="Enter Isrepeatcustomer"        className={inputClassName(formik?.errors?.isrepeatcustomer)} />
                                                <ErrorMessage name="isrepeatcustomer" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Source 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="source"  onChange={formik.handleChange}  value={formik.values.source}   label="Source" type="text" placeholder="Enter Source"        className={inputClassName(formik?.errors?.source)} />
                                                <ErrorMessage name="source" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdby 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/userid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="createdby"     optionLabel="label" optionValue="value" value={formik.values.createdby} onChange={formik.handleChange} options={response} label="Createdby"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.createdby)}   />
                                                    <ErrorMessage name="createdby" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Modifiedby 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/userid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="modifiedby"     optionLabel="label" optionValue="value" value={formik.values.modifiedby} onChange={formik.handleChange} options={response} label="Modifiedby"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.modifiedby)}   />
                                                    <ErrorMessage name="modifiedby" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Pickupconfirmedby 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pickupconfirmedby"  onChange={formik.handleChange}  value={formik.values.pickupconfirmedby}   label="Pickupconfirmedby" type="number" placeholder="Enter Pickupconfirmedby"  min={0}  step="any"    className={inputClassName(formik?.errors?.pickupconfirmedby)} />
                                                <ErrorMessage name="pickupconfirmedby" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Deliveryconfirmedby 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="deliveryconfirmedby"  onChange={formik.handleChange}  value={formik.values.deliveryconfirmedby}   label="Deliveryconfirmedby" type="number" placeholder="Enter Deliveryconfirmedby"  min={0}  step="any"    className={inputClassName(formik?.errors?.deliveryconfirmedby)} />
                                                <ErrorMessage name="deliveryconfirmedby" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Partnerid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/partnerid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="partnerid"     optionLabel="label" optionValue="value" value={formik.values.partnerid} onChange={formik.handleChange} options={response} label="Partnerid"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.partnerid)}   />
                                                    <ErrorMessage name="partnerid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Paymentid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentid"  onChange={formik.handleChange}  value={formik.values.paymentid}   label="Paymentid" type="text" placeholder="Enter Paymentid"        className={inputClassName(formik?.errors?.paymentid)} />
                                                <ErrorMessage name="paymentid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Quantity 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="quantity"  onChange={formik.handleChange}  value={formik.values.quantity}   label="Quantity" type="number" placeholder="Enter Quantity"  min={0}  step="any"    className={inputClassName(formik?.errors?.quantity)} />
                                                <ErrorMessage name="quantity" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
BookingsEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'bookings',
	apiPath: 'bookings/edit',
	routeName: 'bookingsedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default BookingsEditPage;
